var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-typing"},[(_vm.users.length === 1)?_c('span',[_vm._v(_vm._s(_vm.firstUserName)+" is typing...")]):_c('span',[_vm._v(_vm._s(_vm.firstUserName)+" and "+_vm._s(_vm.users.length - 1)+" more people are typing...")])])}
var staticRenderFns = []

export { render, staticRenderFns }